import React, { Component } from 'react';
import {message, Select} from "antd";

import chevron from '../../../Assets/images/chevron.svg';
import AllState from "../../../Assets/data/stateList.json";

class BillingInfo extends Component {
	constructor(props) {
		super(props);
	}

	// Render all state
	renderAllState = () => {
		return AllState.AllState.map((item, i) => {
			return (<option value={item.abbreviation} key={i}>{item.name}</option>)
		});
	}

	renderForm = () => {
		const {address, errors} = this.props;

		return <div className="billing_info_form">
			<div className='item'>
				<div className="half_size_items">
					<div>
						<input
							id="first-name"
							placeholder="First Name"
							className="form--control text-input"
							value={address?.first_name}
							onChange={(e) => this.props.onAddressChange({ target: { name: 'first_name', value: e.target.value }})}
						></input>
						{
							errors && errors['address.first_name'] ?
								<label className="new_err_msg"><i className="las la-info-circle"></i> {errors['address.first_name']}</label>
								: ''
						}
					</div>

					<div>
						<input
							id="last-name"
							placeholder="Last Name"
							value={address?.last_name}
							className="form--control text-input ml-2"
							onChange={(e) => this.props.onAddressChange({ target: { name: 'last_name', value: e.target.value }})}
						></input>
						{
							errors && errors['address.last_name'] ?
								<label className="new_err_msg"><i className="las la-info-circle"></i> {errors['address.last_name']}</label>
								: ''
						}
					</div>
				</div>
			</div>

			<div className='item'>
				<div className="half_size_items special-item">
					<div>
						<input
							value={address?.address}
							id="billing-addres-line-1"
							className="form--control address-input"
							placeholder="Billing Address"
							onChange={(e) => this.props.onAddressChange({ target: { name: 'address', value: e.target.value }})}
						></input>
						{
							errors && errors['address.address'] ?
								<label className="new_err_msg"><i className="las la-info-circle"></i> {errors['address.address']}</label>
								: ''
						}
					</div>

					<div>
						<Select
							name="state"
							showArrow={true}
							bordered= {false}
							placeholder="State"
							className='form--control select-input'
							value={address?.state || undefined}
							suffixIcon={<img src={chevron} alt="" />}
							onChange={(value) => this.props.onAddressChange({ target: { name: 'state', value: value }})}
						>
							{this.renderAllState()}
						</Select>
						{
							errors && errors['address.state'] ?
								<label className="new_err_msg"><i className="las la-info-circle"></i> {errors['address.state']}</label>
								: ''
						}
					</div>

					{/* <input
						placeholder="Billing Address Line 2"
						id="billing-addres-line-2"
						className="form--control"
						style={{ minWidth: "425px", height: 50, border: '2px solid #E6E6E6', backgroundColor: '#ffffff', marginLeft: "30px" }}
					></input> */}
				</div>
			</div>

			<div className='item'>
				<div className="half_size_items">
					<div>
						<input
							id="zip-code"
							value={address?.zip_code}
							className="form--control text-input"
							placeholder="Zip Code"
							onChange={(e) => this.props.onAddressChange({ target: { name: 'zip_code', value: e.target.value }})}
						></input>
						{
							errors && errors['address.zip_code'] ?
								<label className="new_err_msg"><i className="las la-info-circle"></i> {errors['address.zip_code']}</label>
								: ''
						}
					</div>

					<div>
						<input
							type="text"
							name="city"
							placeholder="City"
							value={address?.city}
							className="form--control text-input ml-2"
							onChange={(e) => this.props.onAddressChange({ target: { name: 'city', value: e.target.value }})}
						/>
						{
							errors && errors['address.city'] ?
								<label className="new_err_msg"><i className="las la-info-circle"></i> {errors['address.city']}</label>
								: ''
						}	
					</div>
				</div>
			</div>

			<div className='item'>
				<div className="half_size_items">
					{/* <input
						id="country"
						value={address?.country}
						placeholder="Country"
						className="form--control"
						style={{ minWidth: "425px", height: 50, border: '2px solid #E6E6E6', backgroundColor: '#ffffff' }}
					></input> */}
				</div>
			</div>
		</div>
	}

	render () {
		return <React.Fragment>
			{this.renderForm()}
		</React.Fragment>
	}
}

export default BillingInfo;